/* eslint-disable */

import { getLocalStorageItem } from '@/modules/localStorageManager';

const getPosthog = () => {
    if (
        typeof window !== 'undefined' &&
        window.posthog &&
        window.posthog.__SV
    ) {
        return window.posthog;
    }
    return null;
};

export const pageView = () => {
    getPosthog()?.capture('$pageview');
};

export const identify = (userId) => {
    getPosthog()?.identify(userId, {
        gclid: getLocalStorageItem('gclid'),
        msclkid: getLocalStorageItem('msclkid')
    });
};

export const ctaClicked = ({ destination, text, location, type }) => {
    getPosthog()?.capture('CTA Clicked', {
        destination,
        text,
        location,
        type,
        url: window.location.href
    });
};

export const clientCreated = (client) => {
    getPosthog()?.capture('Client Created', {
        clientId: client.clientId,
        name: client.name,
        companyName: client.companyName,
        clientEmail: client.emailAddress
    });
};

export const documentExported = (document, mode) => {
    getPosthog()?.capture('Document Exported', {
        documentType: document?.documentType,
        documentId: document?.documentId,
        exportMethod: mode,
        paymentDueDate: document?.dueDate || document?.document?.dueDate
    });
};

export const documentSaved = (document) => {
    getPosthog()?.capture('Document Saved', {
        documentType: document.documentType,
        documentId: document.documentId
    });
};

export const documentStarted = (documentType) => {
    getPosthog()?.capture('Document Started', {
        documentType
    });
};

export const paymentMethodConnected = (paymentMethod) => {
    getPosthog()?.capture('Payment Method Connected', {
        paymentMethod
    });
};
